import * as types from "../../actions/generalledger/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.FETCH_EMPLOYER_DEDUCTION_FILTER_LIST:
      return action.payload.data;
    default:
      return state;
  }
}
